module.exports = __webpack_public_path__ + "static/media/vendors.d59bab93.svg";